import { render, staticRenderFns } from "./formitem.vue?vue&type=template&id=1432ec76&scoped=true&"
import script from "./formitem.vue?vue&type=script&lang=js&"
export * from "./formitem.vue?vue&type=script&lang=js&"
import style0 from "./formitem.vue?vue&type=style&index=0&id=1432ec76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1432ec76",
  null
  
)

export default component.exports